import { RepositoryFactory } from "@/Apicall/masters/RepositoryFactory";
import defaultTemplates from "../../Apicall/masters/defaultTemplates";
const studio = RepositoryFactory.get("defaultTemplates");

export default {
    getSms({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await defaultTemplates.getSmsTemplates(
                    payload
                );
                commit("SMS_TEMPLATES", data.data);

                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
    getEmails({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await defaultTemplates.getEmailTemplates(
                    payload
                );
                commit("EMAIL_TEMPLATES", data.data);

                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
}